
"use strict"

import 'promise-polyfill/src/polyfill';

import { cursor } from './utility/cursor'
import { init as navigation } from './components/navigation'

import carousel from './components/carousel'
import carouselFull from './components/carousel-full'
import carouselLogo from './components/carousel-logo'
import eventsFilter from './components/eventsFilter'
import expand from './components/expand'
import mobileMenu from './components/mobileMenu'
import mobileMenuExpand from './components/mobileMenuExpand'
import hero from './components/hero'
import pathfinder from './components/pathfinder'
import smoothScrollAnchors from './components/smoothScrollAnchors'
import socialFeed from './components/socialFeed'
import videoLightbox from './components/videoLightbox'
import filterAttrs from './components/filterAttrs'
import filterAttrsMultiple from './components/filterAttrsMultiple'
import splitText from './components/splitText'
import animateOnView from './components/animateOnView'
import tabs from './components/tabs'

import programmeCarousel from './components/programmeCarousel'



// jsx-dom ie11 bug: https://github.com/proteriax/jsx-dom/pull/37
window.HTMLTemplateElement = window.HTMLTemplateElement || Function


// init components
navigation()
carousel()
carouselFull()
carouselLogo()
eventsFilter()
pathfinder()
socialFeed()
videoLightbox()
filterAttrs()
filterAttrsMultiple()
splitText()
animateOnView()
hero()
tabs()
programmeCarousel()

mobileMenu({
	menu: '.site-menu-mobile',
	openClass: 'is-open',
	noScrollClass: 'site-menu-mobile-noscroll',
	overlayClass: 'site-menu-mobile-overlay',
	openSelector: '.js-site-menu-mobile--open',
	closeSelector: '.js-site-menu-mobile--close',
	toggleSelector: '.js-site-menu-mobile--toggle'
})
mobileMenuExpand()

smoothScrollAnchors(function() {
	return 0 - (document.querySelector('.site-header').clientHeight + 15)
})

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})


cursor().onUpdate(pos => {
   document.documentElement.style.setProperty('--mouse-position-x', `${pos.easedPercentX.toFixed(5) }`)
   document.documentElement.style.setProperty('--mouse-position-y', `${pos.easedPercentY.toFixed(5) }`)
})